import {BillingStatus as BillingStatuses} from 'src/openapi/admin/models/BillingStatus';

export const BILLING_STATUS_CAPTIONS = {
    [BillingStatuses.IN_GOOD_STANDING]: 'In Good Standing',
    [BillingStatuses.HARD_LOCK_GENERAL_MESSAGING]: 'Hard Lock - General Messaging',
    [BillingStatuses.HARD_LOCK_BILLING_SPECIFIC]: 'Hard Lock Billing Specific',
};

export const LICENSE_AND_FEATURES_SUB_TABS = {
    FEATURES_AND_LIMITS: {
        name: 'features-and-limits',
        caption: 'Features and Limits',
    },
    CRM: {
        name: 'crm',
        caption: 'CRM',
    },
    SSO: {
        name: 'sso',
        caption: 'SSO',
    },
    REPORTS: {
        name: 'reports',
        caption: 'Reports',
    },
    CONNECTOR_LIMITS: {
        name: 'connector-limits',
        caption: 'Connector Limits',
    },
};
